import { listen, qs } from '@fluorescent/dom';

const selectors = {
  badgeText: '.spr-badge-caption',
  reviewsSection: '.shopify-product-reviews-wrapper',
};

export default function () {
  const reviewsBadgeText = qs(selectors.badgeText, document);
  const reviewsSection = qs(selectors.reviewsSection, document);

  const button = document.createElement('button');
  button.classList.add('reviews__anchor-trigger');

  reviewsBadgeText.parentNode.insertBefore(button, reviewsBadgeText);
  button.appendChild(reviewsBadgeText);

  button.tabIndex = '0';

  listen(button, 'click', e => {
    e.preventDefault();
    reviewsSection && reviewsSection.scrollIntoView({ behavior: 'smooth' });
  });
}
